import axios from 'axios'
import {
    STAGIAIRE_DETAILS_FAIL,
    STAGIAIRE_DETAILS_REQUEST,
    STAGIAIRE_DETAILS_SUCCESS,
    STAGIAIRE_LOGIN_FAIL,
    STAGIAIRE_LOGIN_REQUEST,
    STAGIAIRE_LOGIN_SUCCESS,
    STAGIAIRE_LOGOUT,
    STAGIAIRE_REGISTER_FAIL,
    STAGIAIRE_REGISTER_REQUEST,
    STAGIAIRE_REGISTER_SUCCESS,

    STAGIAIRE_ADD_FAIL,
    STAGIAIRE_ADD_REQUEST,
    STAGIAIRE_ADD_SUCCESS,

    STAGIAIRE_UPDATE_PROFILE_REQUEST,
    STAGIAIRE_UPDATE_PROFILE_SUCCESS,
    STAGIAIRE_UPDATE_PROFILE_FAIL,
    STAGIAIRE_DETAILS_RESET,
    STAGIAIRE_LIST_FAIL,
    STAGIAIRE_LIST_REQUEST,
    STAGIAIRE_LIST_SUCCESS,
    STAGIAIRE_LIST_RESET,
    STAGIAIRE_DELETE_REQUEST,
    STAGIAIRE_DELETE_SUCCESS,
    STAGIAIRE_DELETE_FAIL,
    STAGIAIRE_UPDATE_REQUEST,
    STAGIAIRE_UPDATE_SUCCESS,
    STAGIAIRE_UPDATE_FAIL
} from './../constants/stagiaireConstants.js'

// Stagiaire stagiaire STAGIAIRE 
export const login = (email) => async (dispatch) => {
    try {
        dispatch({
            type: STAGIAIRE_LOGIN_REQUEST,
        })

        const config = {
            headers: {
                'Content-type': 'application/json'
            },
        }

        const { data } = await axios.post(
            '/api/stagiaires/login',
            { email },
            config
        )

        dispatch({
            type: STAGIAIRE_LOGIN_SUCCESS,
            payload: data
        })

        localStorage.setItem('stagiaireInfo', JSON.stringify(data))
    } catch (error) {
        dispatch({
            type: STAGIAIRE_LOGIN_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message
        })
    }
}

export const register = (name, email, phonenumber ,formation ,condition ) => async (dispatch) => {
    try {
        dispatch({
            type: STAGIAIRE_REGISTER_REQUEST,
        })

        const config = {
            headers: {
                'Content-type': 'application/json'
            },
        }

        const { data } = await axios.post(
            '/api/stagiaires/',
            { name, email, phonenumber ,formation ,condition},
            config
        )

        dispatch({
            type: STAGIAIRE_REGISTER_SUCCESS,
            payload: data
        })

        dispatch({
            type: STAGIAIRE_REGISTER_SUCCESS,
            payload: data
        })

        localStorage.setItem('stagiaireInfo', JSON.stringify(data))
    } catch (error) {
        dispatch({
            type: STAGIAIRE_REGISTER_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message
        })
    }
}



export const addStagiaire = (name, email ) => async (dispatch) => {
    try {
        dispatch({
            type: STAGIAIRE_ADD_REQUEST,
        })

        const config = {
            headers: {
                'Content-type': 'application/json'
            },
        }

        const { data } = await axios.post(
            '/api/stagiaires/',
            { name, email},
            config
        )

        dispatch({
            type:     STAGIAIRE_ADD_SUCCESS,

            payload: data
        })


        dispatch({
            type:        STAGIAIRE_LOGOUT, 
           
        })

        localStorage.setItem('stagiaireInfo', JSON.stringify(data))
    } catch (error) {
        dispatch({
            type: STAGIAIRE_ADD_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message
        })
    }
}



export const getStagiaireDetails = (id) => async (dispatch, getState) => {
    try {
        dispatch({
            type: STAGIAIRE_DETAILS_REQUEST,
        })

        const { stagiaireRegister: { stagiaireInfo } } = getState()

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${stagiaireInfo.token}`
            },
        }

        const { data } = await axios.get(
            `/api/stagiaires/${id}`,
            config
        )
        dispatch({
            type: STAGIAIRE_DETAILS_SUCCESS,
            payload: data
        })

    } catch (error) {
        dispatch({
            type: STAGIAIRE_DETAILS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message
        })
    }
}

export const updateStagiaireProfile = (stagiaire) => async (dispatch, getState) => {
    try {
        dispatch({
            type: STAGIAIRE_UPDATE_PROFILE_REQUEST,
        })

        const { stagiaireRegister: { stagiaireInfo } } = getState()

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${stagiaireInfo.token}`
            },
        }

        const { data } = await axios.put(
            `/api/stagiaires/profile`,
            stagiaire,
            config
        )

        dispatch({
            type: STAGIAIRE_UPDATE_PROFILE_SUCCESS,
            payload: data
        })

    } catch (error) {
        dispatch({
            type: STAGIAIRE_UPDATE_PROFILE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message
        })
    }
}

export const listStagiaires = () => async (dispatch, getState) => {
    try {
        dispatch({
            type: STAGIAIRE_LIST_REQUEST,
        })

        const { stagiaireRegister: { stagiaireInfo } } = getState()

        const config = {
            headers: {
                Authorization: `Bearer ${stagiaireInfo.token}`
            },
        }

        const { data } = await axios.get(`/api/stagiaires`, config)

        dispatch({
            type: STAGIAIRE_LIST_SUCCESS,
            payload: data
        })

    } catch (error) {
        dispatch({
            type: STAGIAIRE_LIST_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message
        })
    }
}

export const deleteStagiaires = (id) => async (dispatch, getState) => {
    try {
        dispatch({
            type: STAGIAIRE_DELETE_REQUEST,
        })

        const { stagiaireRegister: { stagiaireInfo } } = getState()

        const config = {
            headers: {
                Authorization: `Bearer ${stagiaireInfo.token}`
            },
        }

        // eslint-disable-next-line no-unused-vars
        const { data } = await axios.delete(`/api/stagiaires/${id}`, config)

        dispatch({
            type: STAGIAIRE_DELETE_SUCCESS,
        })

    } catch (error) {
        dispatch({
            type: STAGIAIRE_DELETE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message
        })
    }
}

export const updateStagiaire = (stagiaire) => async (dispatch, getState) => {
    try {
        dispatch({
            type: STAGIAIRE_UPDATE_REQUEST,
        })

        const { stagiaireRegister: { stagiaireInfo } } = getState()

        const config = {
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${stagiaireInfo.token}`
            },
        }

        const { data } = await axios.put(`/api/stagiaires/${stagiaire._id}`, stagiaire, config)

        dispatch({ type: STAGIAIRE_UPDATE_SUCCESS })

        dispatch({
            type: STAGIAIRE_DETAILS_SUCCESS,
            payload: data
        })

        dispatch({ type: STAGIAIRE_DETAILS_RESET })

    } catch (error) {
        dispatch({
            type: STAGIAIRE_UPDATE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message
        })
    }
}

export const logout = () => (dispatch) => {
    localStorage.removeItem('stagiaireInfo')
    dispatch({ type: STAGIAIRE_LOGOUT } )
    dispatch({ type: STAGIAIRE_DETAILS_RESET })
    dispatch({ type: STAGIAIRE_LIST_RESET })
}






